import styled, { css } from 'foundations-theming-specialty/utils';
import { MenuButton } from '../Menu';
export const StyledMenuButton = styled(MenuButton)(({
  theme
}) => {
  return css(["border-radius:50%;width:32px;height:32px;border:1px solid ", ";align-self:center;justify-self:center;align-content:center;justify-content:center;display:flex;background:", ";flex-wrap:wrap;&:hover{background:", ";border:1px solid ", ";}& > svg{display:flex;fill:", ";}"], ({
    $isOpen
  }) => $isOpen ? theme.color['global-shell-border-dark'] : theme.color['global-shell-border-search-btn-border-default'], ({
    $isOpen
  }) => $isOpen ? theme.color['global-shell-fill-nav-item-hover'] : 'transparent', theme.color['global-shell-fill-nav-item-hover'], theme.color['global-shell-border-dark'], theme.color['global-shell-icon-nav-item-default']);
});
StyledMenuButton.displayName = 'StyledMenuButton';